import {getSignatureObject} from './getSignatureObject';

export function getSignature(arg: any): string {
    return JSON.stringify(getSignatureObject(arg));
}
